module.exports = __webpack_public_path__ + "static/img/intro.ecfd889.svg";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/images/intro.svg
// module id = oLgW
// module chunks = 27